import { observer } from 'mobx-react-lite'
import { DoubleOptInSettingLayout } from 'pages/settings/pages/doubleOptIn/ui/doubleOptInSetting/DoubleOptInSettingLayout'
import { useVoicemailDropContext } from 'pages/settings/pages/personal/pages/account/pages/voicemailDrop/context/voicemailDropContext'

export const VoicemailDropToggle = observer(() => {
  const { voicemailDropActive, toggleVoicemailDrop, loading } = useVoicemailDropContext()

  return (
    <DoubleOptInSettingLayout
      title={'Voicemail drop'}
      titleVariant={'body-lg-medium'}
      description={'Drop prerecorded audio into voicemail when calls aren’t answered'}
      checked={voicemailDropActive}
      onToggle={toggleVoicemailDrop}
      disabled={loading}
    />
  )
})
